<template>
    <div class="messages">
        <!--<div role="alert" :class="item.class" v-for="item in messages">
            <button type="button" data-dismiss="alert" aria-label="Close" class="close"><span aria-hidden="true" class="s7-close"></span></button><span :class="item.icon" v-if="item.icon"></span>{{ item.message }}
        </div>-->
        <b-alert show dismissible :variant="item.variant" v-for="item in messages" :key="item.message">{{ item.message }}</b-alert>
    </div>
</template>

<script>
    import eventBus, {SUCCESS, ERROR, INFO}  from "../../../utils/messages"

    export default {
        props: {
            target: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                notifications: [],
                icons: {
                    [SUCCESS]: 'icon s7-check',
                    [ERROR]: null,
                    [INFO]: 'icon s7-info',
                },
                classes: {
                    [SUCCESS]: 'alert alert-dismissible alert-success',
                    [ERROR]: 'alert alert-dismissible alert-danger',
                    [INFO]: 'alert alert-dismissible alert-info',
                },
                variants: {
                    [SUCCESS]: 'success',
                    [ERROR]: 'danger',
                    [INFO]: 'info',
                }
            }
        },
        computed: {
            messages: function () {
                return this.notifications;
            },
        },
        created() {
            eventBus.bus.$on('message', ($event) => {
                $event.icon     = this.icons[$event.type];
                $event.class    = this.classes[$event.type];
                $event.variant    = this.variants[$event.type];

                if($event.target !== null && $event.target !== undefined && $event.target !== this.target)
                    return;

                // Append message
                this.notifications.push($event);

                // Overwrite message
                //this.notifications = [$event];
            });
            eventBus.bus.$on('message.clear', ($event) => {
                this.notifications = [];
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/default/messages.vue